/**
 * The eight integrity questions, in the order an operator reads them.
 *
 * The counts themselves are computed server-side by
 * supabase/functions/_shared/winner-integrity.ts and arrive on the publish
 * check as `integrity_audit`. This is only the wording and the ordering, so
 * the panel shows all eight lines whether or not any of them found anything.
 */
export type AuditCounts = {
  games_with_winner: number;
  winner_is_own_team: number;
  winner_not_in_game: number;
  feed_to_missing_game: number;
  loser_next_to_nothing: number;
  same_team_both_sides: number;
  feed_crossing_events: number;
  feed_from_same_or_later_round: number;
};

export const AUDIT_LABELS: Array<{ key: keyof AuditCounts; label: string; bad: boolean; indent?: boolean }> = [
  { key: 'games_with_winner', label: 'Games with a winner', bad: false },
  { key: 'winner_is_own_team', label: "Winner is one of the game's own teams", bad: false, indent: true },
  { key: 'winner_not_in_game', label: 'Winner is NOT in the game at all', bad: true, indent: true },
  { key: 'feed_to_missing_game', label: 'Feeds pointing at a game that does not exist', bad: true },
  { key: 'loser_next_to_nothing', label: 'Loser sent to a game that does not exist', bad: true },
  { key: 'same_team_both_sides', label: 'Same team on both sides of a game', bad: true },
  { key: 'feed_crossing_events', label: 'Feeds crossing between events', bad: true },
  { key: 'feed_from_same_or_later_round', label: 'Feed from a game in the same or later round', bad: true },
];

/** How many of the six problem lines found something. */
export function auditProblemCount(counts?: AuditCounts | null): number {
  if (!counts) return 0;
  return AUDIT_LABELS.filter((l) => l.bad).reduce((n, l) => n + (Number(counts[l.key]) || 0), 0);
}
